import React from 'react';

/**
 * Skeleton — base shimmer block (pure Tailwind, no CSS file).
 *
 * A muted base block with a gradient sweep overlay animated by `animate-shimmer`
 * (defined in tailwind.config.js). Compose these to build any loading
 * placeholder: set width / height / rounding through `className`.
 *
 * Example:
 *   <Skeleton className="h-4 w-24 rounded-md" />
 */
const Skeleton = ({ className = '' }) => (
  <div className={`relative overflow-hidden bg-[#E6ECF5] dark:bg-[#2c313a] ${className}`}>
    <div className="absolute inset-0 -translate-x-full animate-shimmer motion-reduce:animate-none bg-gradient-to-r from-transparent via-white/60 dark:via-white/10 to-transparent" />
  </div>
);

export default Skeleton;
